import { ca } from '@cian/analytics';
import { IApplicationState } from '../../types/redux';
import { createCianAnalyticsPageViewObject } from '../../utils/createCianAnalyticsPageViewObject';

export const trackPageView = (state: IApplicationState) => {
  ca('pageviewSite', createCianAnalyticsPageViewObject(state));
};
